import { NAV_BRAND } from '@/config'
import { PORTAL_TYPE_FPO } from '@/config/constants'
import { COMPANY_DETAIL, JOB_DETAIL, JOB_PREVIEW } from '@/page/constants'

import { reduce, forEach } from '../../utils/object'
import { COMPANY, JOB } from '../constants'

import defaultState, {
  defaultFilters,
  defaultOrder,
  defaultQuery,
  defaultResultsMap,
  defaultSelectedId,
  defaultShowFirstResult,
  defaultSourceJobId,
  defaultType
} from './defaultState'

const unwrapSearchState = state => state.search || defaultState
const resolveType = (state, typeOverride) => {
  const { type = defaultType } = unwrapSearchState(state)
  return typeOverride || type
}
const unwrapResultsState = (state, typeOverride) => {
  const { results = defaultResultsMap } = unwrapSearchState(state)
  return results[resolveType(state, typeOverride)]
}

export const getSearchState = state => {
  const { query, type, filters, fixed } = unwrapSearchState(state)
  return { query, type, filters, fixed }
}
export const getReducedSearchState = state => {
  const { type, ...searchState } = getSearchState(state)
  return { type, ...reduce(searchState) }
}
export const getSearchQuery = state => unwrapSearchState(state).query || defaultQuery
export const getSearchType = state => unwrapSearchState(state).type || defaultType
export const getShowFirstResult = state => unwrapSearchState(state).showFirstResult || defaultShowFirstResult
export const getShowMobileSearchForm = state => unwrapSearchState(state).showMobileSearchForm
export const getSearchFilters = state => unwrapSearchState(state).filters || defaultFilters
export const getSelectedId = (state, typeOverride) => unwrapResultsState(state, typeOverride).selectedId || defaultSelectedId
export const getSourceId = (state, typeOverride) => unwrapResultsState(state, typeOverride).sourceJobId || defaultSourceJobId
export const getSelectedJobId = state => getSelectedId(state, JOB)
export const getSourceJobId = state => getSourceId(state, JOB)
export const getSelectedCompanyId = state => getSelectedId(state, COMPANY)
export const getUpdateUrl = state => unwrapSearchState(state).updateUrl
export const areFiltersCollapsed = state => unwrapSearchState(state).collapsedFilters
export const getAutoSelectItem = state => unwrapSearchState(state).autoSelectItem
export const getActiveFiltersCount = state => {
  let count = 0
  const filters = getSearchFilters(state)
  forEach(filters, items => { count += items.length })
  return count
}
export const getSearchOrder = state => getSearchQuery(state).order || defaultOrder
export const areFiltersHidden = state => {
  const { hiddenFilters } = unwrapSearchState(state)
  const { page: { type } = {} } = state

  return hiddenFilters && ([JOB_DETAIL, JOB_PREVIEW, COMPANY_DETAIL].includes(type) || NAV_BRAND.portal_type === PORTAL_TYPE_FPO)
}
export const canSelectFirstResult = state => {
  return !getSelectedCompanyId(state) && !getSelectedJobId(state) && getShowFirstResult(state)
}
